import { VectorStyle } from '../../../layer-type-services/vector-tile/twc-vector-tile.layer';
import { TwcProduct } from '../../../twc-products';
import { ARROW_CIM_SYMBOL } from './high-level-significant.graphics';
import { TWC_HIGH_LEVEL_SIGNIFICANT_VECTOR_STYLE_LAYERS } from './high-level-significant.mapbox-style';
import UniqueValueRenderer from '@arcgis/core/renderers/UniqueValueRenderer';

export const TWC_HIGH_LEVEL_SIGNIFICANT_VECTOR_STYLE: VectorStyle = {
  layers: TWC_HIGH_LEVEL_SIGNIFICANT_VECTOR_STYLE_LAYERS,
  sprite: `assets/weather/sprites/High_Level_Sig_Wx`,
  glyphs: `assets/weather/glyphs/Font12_Regular/0-255.pbf`
};

export const HIGH_LEVEL_SIGNIFICANT_PRODUCT_DATA: TwcProduct = {
  id: 'high-level-significant',
  defaultProductId: '1262', // do not change
  productName: 'Weather-High-Level-Significant-Forecast-TWC',
  label: 'High Level Significant',
  weatherType: 'HI_LVL_SIG_WX_FCST',
  description: 'TWC product (vector) - High Level Significant Weather Forecast',
  series: 'Forecast',
  timeSlicePeriodInMinutes: 1,
  lodMax: 5,
  protocol: 'VectorTile',
  forecastTimeSlicePeriod: 0,
  flightLevelProductIds: {},
  zOrder: 90,
  layerSpecs: {
    vectorTile: { vectorStyle: TWC_HIGH_LEVEL_SIGNIFICANT_VECTOR_STYLE },
    geoJSON: {
      geometryType: 'polyline',
      declutter: true,
      maxScale: 9244648.868618, // https://developers.arcgis.com/documentation/mapping-apis-and-services/reference/zoom-levels-and-scale/
      renderer: new UniqueValueRenderer({
        field: 'layer_name',
        uniqueValueInfos: [
          {
            value: 'JET_STREAM',
            symbol: ARROW_CIM_SYMBOL
          }
        ]
      })
    }
  }
};
